import { render } from "./BuyRatingList.vue?vue&type=template&id=42f6fcc7&scoped=true"
import script from "./BuyRatingList.vue?vue&type=script&lang=ts"
export * from "./BuyRatingList.vue?vue&type=script&lang=ts"

import "./BuyRatingList.vue?vue&type=style&index=0&id=42f6fcc7&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-42f6fcc7"

export default script